<template>
  <q-page>
    
    <div class="row content">
      <div class="col-3 content">
        <q-datetime v-model="dateFrom" type="date" :float-label="$t('global.DateFrom')" format="D.MMM.YYYY" />
      </div>
      
      <div class="col-3 content">
        <q-datetime v-model="dateTo" type="date" :float-label="$t('global.DateTo')" format="D.MMM.YYYY" />
      </div>
      
      <div class="col-auto content">
        <q-btn-toggle
          v-model="processedType"
          toggle-color="primary"
          :options="[
            {label: this.$t('global.Unfinished'), value: 1},
            {label: this.$t('global.Processed'), value: 2},
            {label: this.$t('global.All'), value: 3}
          ]"
        />
      </div>
    </div>
   

    <div class="row">
      <div class="col">
        <EventSummary v-bind:dateFrom="dateFrom" v-bind:dateTo="dateTo" v-bind:processedType="processedType"></EventSummary>
      </div>
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import EventSummary from '@/components/Summary/EventSummary'

export default {
  name: 'Journal',
  components: {
    EventSummary,
  },
  data: function () {
    return {
      dateFrom: date.startOfDate(Date.now(), 'month'),
      dateTo: date.addToDate(Date.now(), { days: 0 }),
      processedType: 1
    }
  }
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
